import { Env, getExecutionEnv } from './env';

export const removeEmptyKeys = (
  obj: Record<string, any>,
): Record<string, any> => Object.entries(obj).reduce((acc, [key, value]) => {
  if (value !== null && value !== undefined && value !== '') {
    acc[key] = value;
  }
  return acc;
}, {} as Record<string, any>);

export const isDevelopment = (): boolean => getExecutionEnv() === Env.DEVELOPMENT;

export const isWindowUndefined = (): boolean => typeof window === 'undefined';

export const parseQueryString = (
  search: string,
): Record<string, string> => Object.fromEntries(new URLSearchParams(search));

export const shouldTrackUserEvents = (): boolean => getExecutionEnv() === Env.PRODUCTION;

export const getUniqueValues = (data: any[], key: string): any[] => Array.from(
  new Map(data.map((item) => [item[key], item])).values(),
);
